<template>
  <section class="app-modal__section payment-plan-pay-modal__section-banking payment-plan-pay-modal__section--banking-compact">
    <header class="payment-plan-pay-modal__section-head payment-plan-pay-modal__section-head--banking">
      <h5>{{ text.payModal.banking.title }}</h5>
      <p>{{ bankingSubtitle }}</p>
    </header>

    <div
      class="app-modal__grid two-columns payment-plan-pay-modal__bank-grid"
      :class="accountOnly ? 'payment-plan-pay-modal__bank-grid--two-columns' : 'payment-plan-pay-modal__bank-grid--three-columns'"
    >
      <div v-if="!accountOnly" class="app-modal-field">
        <span>{{ text.payModal.banking.fields.paymentMethod }}</span>
        <multiselect
          v-model="paymentMethodModel"
          :options="paymentMethodOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="false"
          :max-height="128"
          open-direction="down"
          :placeholder="text.payModal.banking.placeholders.paymentMethod"
          class="app-modal-select"
        >
          <template #noResult>
            <span>{{ text.payModal.banking.emptyOption }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.payModal.banking.emptyOption }}</span>
          </template>
        </multiselect>
      </div>

      <label v-if="!accountOnly" class="app-modal-field payment-plan-pay-modal__operation-field">
        <span>{{ text.payModal.banking.fields.operationNumber }}</span>
        <input
          v-model.trim="operationNumberModel"
          type="text"
          class="form-control"
          maxlength="80"
          autocomplete="off"
          :placeholder="text.payModal.banking.placeholders.operationNumber"
        />
      </label>

      <div class="app-modal-field">
        <span>{{ text.payModal.banking.fields.paymentAccount }}</span>
        <multiselect
          v-model="paymentAccountModel"
          :options="paymentAccountOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="128"
          open-direction="down"
          :placeholder="text.payModal.banking.placeholders.paymentAccount"
          class="app-modal-select"
        >
          <template #noResult>
            <span>{{ text.payModal.banking.emptyOption }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.payModal.banking.emptyOption }}</span>
          </template>
        </multiselect>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PayModalSectionPaymentInfo',
  emits: ['update:paymentMethod', 'update:operationNumber', 'update:paymentAccount'],
  props: {
    text: {
      type: Object,
      required: true,
    },
    paymentMethodOptions: {
      type: Array,
      default: () => [],
    },
    paymentAccountOptions: {
      type: Array,
      default: () => [],
    },
    paymentMethod: {
      type: Object,
      default: null,
    },
    operationNumber: {
      type: String,
      default: '',
    },
    paymentAccount: {
      type: Object,
      default: null,
    },
    accountOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bankingSubtitle() {
      if (this.accountOnly) {
        return String(this.text?.payModal?.banking?.subtitleAccountOnly || 'Selecciona la cuenta de pago.').trim();
      }

      return String(this.text?.payModal?.banking?.subtitle || '').trim();
    },
    paymentMethodModel: {
      get() {
        return this.paymentMethod;
      },
      set(value) {
        this.$emit('update:paymentMethod', value || null);
      },
    },
    operationNumberModel: {
      get() {
        return String(this.operationNumber || '');
      },
      set(value) {
        this.$emit('update:operationNumber', String(value || '').trim());
      },
    },
    paymentAccountModel: {
      get() {
        return this.paymentAccount;
      },
      set(value) {
        this.$emit('update:paymentAccount', value || null);
      },
    },
  },
};
</script>
